/**
 * Configuration constants for Feature Article Component
 */

export const SLIDER_CONFIG = {
    DESKTOP_ROWS: 4,                    // Shows 2x2 grid of articles on desktop
    MOBILE_CENTER_PADDING_LARGE: '150px',  // For tablets (<=768px)
    MOBILE_CENTER_PADDING_MEDIUM: '75px',  // For small phones (<=640px)
    MOBILE_CENTER_PADDING_SMALL: '50px',   // For very small phones (<=480px)
    TRANSITION_SPEED: 1500,             // Matches other sliders in the app (1.5 seconds)
    INIT_RETRY_DELAY: 60,               // Small delay to let DOM settle (60ms)
    INIT_MAX_RETRIES: 5,                // Maximum initialization attempts
    MIN_WIDTH_THRESHOLD: 10,            // Minimum width to consider layout ready
    MOBILE_BREAKPOINT: '(max-width: 768px)'
};

export const SELECTORS = {
    COMPONENT: '.news-feed-feature-columns, .news-feed-feature-rows',
    ARTICLES_CONTAINER: '.ss-articles-container',
    SLIDES_CONTAINER: '.ss-feature-slides-container',
    CONTROLS_CONTAINER: '.ss-feature-controls-container',
    COMPONENT_COLUMN: '.ss-component-column',
    CONTROL_WRAPPER: '.ss-slick-control-wrapper',
    CONTROL_BUTTONS: '.ss-slick-control-buttons',
    PREV_ARROW: '.slick-prev',
    NEXT_ARROW: '.slick-next',
    MOBILE_PREV_ARROW: '.slick-prev-mobile-carousel',
    MOBILE_NEXT_ARROW: '.slick-next-mobile-carousel',
    COMPONENT_CONTENT: '.ss-component-content'
};

